export const svgStringToDataUrlEncoded = (svgString: string): string => {
  return `data:image/svg+xml,${encodeURIComponent(svgString)}`;
};
